import { lazy } from "react";

const Configuration = lazy(() => import("pages/Configuration/Configuration"));

export const configuration = [
  {
    path: "configuration",
    element: <Configuration />,
  },
];
